import { Box, Stack } from '@mui/material';
import { LiveTranscriptMessage } from 'src/components/Assistant/live-transcript/live-transcript-message';
import {
  liveTranscriptMessagesContainerSx,
  liveTranscriptStreamingDotSx,
  liveTranscriptStreamingIndicatorSx,
} from 'src/components/Assistant/live-transcript/live-transcript.styles';
import { LiveTranscriptMessagesProps } from 'src/components/Assistant/live-transcript/live-transcript.types';
import { mapSegmentsWithSpeakerChanges } from 'src/components/Assistant/live-transcript/live-transcript.utils';

export const LiveTranscriptMessages = ({
  groupedSegments,
  isStreaming,
  scrollRef,
  onScroll,
  onCopySegment,
  searchQuery,
  currentMatchIndex,
  matchOffsetBySegmentId,
}: LiveTranscriptMessagesProps) => {
  const rows = mapSegmentsWithSpeakerChanges(groupedSegments);

  return (
    <Stack ref={scrollRef} onScroll={onScroll} sx={liveTranscriptMessagesContainerSx}>
      {rows.map(({ segment, showSpeakerChange }) => (
        <LiveTranscriptMessage
          key={segment.id}
          segment={segment}
          showSpeakerChange={showSpeakerChange}
          onCopy={onCopySegment}
          searchQuery={searchQuery}
          matchOffset={matchOffsetBySegmentId.get(segment.id) ?? 0}
          currentMatchIndex={currentMatchIndex}
        />
      ))}

      {isStreaming ? (
        <Stack direction="row" sx={liveTranscriptStreamingIndicatorSx}>
          {[0, 1, 2].map((dot) => (
            <Box key={dot} sx={liveTranscriptStreamingDotSx(dot)} />
          ))}
        </Stack>
      ) : null}
    </Stack>
  );
};
